module.exports = __webpack_public_path__ + "img/boy-2.a11012b6.png";